export type InstantTourProvidersLike = {
  inPersonProvider?: unknown;
  liveVideoProvider?: unknown;
  selfGuidedProvider?: unknown;
};

/**
 * True when any instant-tour provider can take a booking — the same signal
 * that gates the HDP "Book tour" CTA.
 */
export function hasBookableTourProvider(providers: InstantTourProvidersLike | null | undefined): boolean {
  return Boolean(providers?.inPersonProvider || providers?.liveVideoProvider || providers?.selfGuidedProvider);
}
